import {Component, OnInit, OnDestroy, HostListener, ChangeDetectorRef} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {BUSINESS_COLOR, SHOW_SETTING, SHOW_VOIP} from "../../app.constants";
import {AccountService} from "../../singelton/account.service";
import {IMessage} from "../../shared/model/chat.message.model";
import {ICallReportModel} from "../../shared/model/callReport.model";
import {IPhone} from "../../shared/model/phone.model";
import {CallService} from "../../entities/Report/call-report.service";
import {HttpResponse} from "@angular/common/http";
import {isNullOrUndefined} from "@swimlane/ngx-datatable/release/utils";
import * as moment from 'jalali-moment';
import {FeatureFlagsService} from "../../singelton/feature-flags.service";
import {EventService} from "../../singelton/event.service";
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {NotificationDialogComponent} from '../../dashboards/dashboard1/notification-dialog.component';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit, OnDestroy {
  // color = 'default';
  show_voip: any = SHOW_VOIP;

  // color = 'greendark';
  show_setting: any = SHOW_SETTING;
  business_color: any = BUSINESS_COLOR;
  color = this.business_color;
  messages : IMessage[];
  calls : Array<ICallReportModel> = Array();
  showSettings = false;
  showMinisidebar = false;
  showDarktheme = false;
  showDiv = false;
  showRtl = true;
  public innerWidth: any = window.innerWidth;
  private readonly mobileBreakpoint = 768;
  private routerSub: Subscription;
  showInstallBanner = false;
  iosInstall = false;
  phoneTitle = 'رصد';
  private installPrompt: any;
  private readonly onInstallReady = () => this.captureInstallPrompt();

  public config: PerfectScrollbarConfigInterface = {};

  /** Mobile drawer is open when sidebar is not in mini (hidden) mode */
  get isMobileSidebarOpen(): boolean {
    return this.innerWidth < this.mobileBreakpoint && !this.showMinisidebar;
  }

  get isPhone(): boolean {
    return this.innerWidth < this.mobileBreakpoint;
  }

  syncFeatureFlags() {
    this.show_voip = this.featureFlags.flags.showVoip;
    this.show_setting = this.featureFlags.flags.showSetting;
  }

  constructor(public router: Router,
              private activatedRoute: ActivatedRoute,
              public accountService: AccountService,
              public changeDetectorRef: ChangeDetectorRef,
              public callService: CallService,
              private featureFlags: FeatureFlagsService,
              private eventService: EventService,
              private modalService: NgbModal) {

    this.syncFeatureFlags();
    this.eventService.changeSettingEvantAdd.subscribe(() => {
      this.featureFlags.load();
      setTimeout(() => this.syncFeatureFlags(), 300);
    });

    this.accountService.chatMessageAdded.subscribe((data) => {

      // reading content of the received message
      let m : IMessage;

      console.log(" ----  >>>>>> o O " + data)

      m = JSON.parse(data);

      //check different types of notifications
      if(m.type === "CALL_CENTER_NOTIFICATION") {
        let call :ICallReportModel;

        let phone :IPhone[];

        call = JSON.parse(m.content);

  //     phone = JSON.parse(call.phones)

       //  alert(" ----- >>>> phonesssss : " + call);
       //  alert(" ----- >>>> phonesssss : " + call.phones[0].customer.id);
        // alert(" ----- >>>> phonesssss : " + call.phones.length);
        //
        // if(!this.showDiv)
        // this.calls.push(call);
        // else
         this.calls.unshift(call);

       // this.changeDetectorRef.markForCheck()
        //this.calls=this.calls.slice();


        // open the phone side bar if it is closed
        this.openAutoMsgArrived()

      }

    });

  }

  ngOnInit() {
    if (this.router.url === '/') {
      this.router.navigate(['/dashboard/dashboard']);
    }
    this.handleLayout();
    this.syncFeatureFlags();

    if (this.showRtl) {
      sessionStorage.setItem('lang', 'fa');
    } else {
      sessionStorage.setItem('lang', 'en');
    }

    this.syncPhoneHeading();
    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        this.closeMobileSidebar();
        this.syncPhoneHeading();
      });

    this.captureInstallPrompt();
    this.maybeShowIosInstall();
    (window as any).addEventListener('crm-install-ready', this.onInstallReady);
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
    (window as any).removeEventListener('crm-install-ready', this.onInstallReady);
  }

  captureInstallPrompt() {
    const prompt = (window as any).__crmInstallPrompt;
    if (!prompt || this.isStandalone() || localStorage.getItem('crm-pwa-dismiss')) {
      return;
    }
    this.installPrompt = prompt;
    this.iosInstall = false;
    this.showInstallBanner = true;
  }

  maybeShowIosInstall() {
    const ua = window.navigator.userAgent || '';
    const ios = /iphone|ipad|ipod/i.test(ua);
    if (ios && !this.isStandalone() && !localStorage.getItem('crm-pwa-dismiss')) {
      this.iosInstall = true;
      this.showInstallBanner = true;
    }
  }

  isStandalone(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches
      || (window.navigator as any).standalone === true;
  }

  installApp() {
    if (!this.installPrompt) {
      return;
    }
    this.installPrompt.prompt();
    this.installPrompt.userChoice.then(() => {
      this.showInstallBanner = false;
      this.installPrompt = null;
      (window as any).__crmInstallPrompt = null;
    });
  }

  dismissInstall() {
    this.showInstallBanner = false;
    localStorage.setItem('crm-pwa-dismiss', '1');
  }

  goMobile(path: string) {
    this.closeMobileSidebar();
    this.router.navigate([path]);
  }

  isTasksNav(): boolean {
    return this.router.url.indexOf('/page/mobile-dashboard') >= 0
      || this.router.url.indexOf('/page/mytransaction') >= 0;
  }

  isCustomersNav(): boolean {
    return this.router.url.indexOf('/page/customer-page') >= 0
      || this.router.url.indexOf('/page/profile-customer') >= 0;
  }

  isSearchNav(): boolean {
    return this.router.url.indexOf('customer-advanced-search') >= 0
      || this.router.url.indexOf('rapid-search') >= 0;
  }

  onPhoneAction() {
    // Mobile bell opens the same notifications modal as desktop (not VoIP calls).
    this.openNotifications();
  }

  openNotifications() {
    this.modalService.open(NotificationDialogComponent, {
      windowClass: this.isPhone ? 'notification-modal notification-modal--phone' : 'notification-modal',
      backdrop: 'static',
      size: this.isPhone ? undefined : 'lg',
      centered: !this.isPhone
    });
  }

  syncPhoneHeading() {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const data = route.snapshot && route.snapshot.data ? route.snapshot.data : {};
    const url = this.router.url || '';

    if (url.indexOf('mobile-dashboard') >= 0 || url.indexOf('mytransaction') >= 0) {
      this.phoneTitle = 'میز کار من';
    } else if (url.indexOf('customer-page') >= 0) {
      this.phoneTitle = 'مشتریان';
    } else if (url.indexOf('profile-customer') >= 0) {
      this.phoneTitle = 'پرونده مشتری';
    } else if (url.indexOf('customer-advanced-search') >= 0 || url.indexOf('rapid-search') >= 0) {
      this.phoneTitle = 'جستجو';
    } else {
      this.phoneTitle = data['title'] || 'رصد';
    }
  }

  openAutoMsgArrived(){
    if(!this.showDiv)
    {
      // todo comment showDiv call anutomatic for parse
      // this.showDiv = true;


      //fetch the latest when open the calls tab (when the tab is going to open the last element of synchronous api should be deleted to prevent duplication)
      this.loadLastFiveMinusLatest();
    }
}

  showDivf() {
    if(!this.showDiv) {

      // truncate the array to fill compeletly from the server (when open the tab manually)
      this.calls = [];

      //fetch the latest when open the calls tab
      this.loadLastFive();
      this.showDiv = true;

    } else {
      this.showDiv = false;
      // truncate the array when close the sidebar
      this.calls = [];
    }
  }

  onSuccess(data, headers, startIndex) {
    //this.calls = data;
   // alert(" --- >>>>> received data   :    "  + data.length);

    for (let i = startIndex; i < 5; i++) {
      if (!isNullOrUndefined(data[i]))
        this.calls.push(data[i]);
    }
    this.changeDetectorRef.markForCheck()

  }

  onError(error){
  }

  loadLastFive(){
    this.callService.queryForFive({
      page: 0,
      size: 5,
      sort: ['id,desc']
    })
      .subscribe((res: HttpResponse<ICallReportModel[]>) => this.onSuccess(res.body, res.headers, 0), (res: HttpResponse<any>) => this.onError(res.body));

  }

  loadLastFiveMinusLatest(){
    this.callService.queryForFive({
      page: 0,
      size: 5,
      sort: ['id,desc']
    })
      .subscribe((res: HttpResponse<ICallReportModel[]>) => this.onSuccess(res.body, res.headers, 1), (res: HttpResponse<any>) => this.onError(res.body));

  }

  hideDivf() {
    this.showDiv = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleLayout();
  }

  toggleSidebar() {
    this.showMinisidebar = !this.showMinisidebar;
  }

  closeMobileSidebar() {
    if (this.innerWidth < this.mobileBreakpoint) {
      this.showMinisidebar = true;
    }
  }

  onSidebarNavClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target) {
      return;
    }
    const link = target.closest('a') as HTMLAnchorElement;
    if (!link) {
      return;
    }
    // Parent accordion toggles keep the drawer open
    if (link.classList.contains('has-arrow')) {
      return;
    }
    // Leaf menu item — close drawer (NavigationEnd also closes)
    setTimeout(() => this.closeMobileSidebar(), 80);
  }

  handleLayout() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1170) {
      this.showMinisidebar = true;
    } else {
      this.showMinisidebar = false;
    }
  }

  parseDate(value) {
    // alert(' val ' + value);
    let jalaliDate5 = '-';
    if (value) {
      // jalaliDate5 = moment(value).locale('fa').format('jYYYY/jM/jD HH:mm'); // 1367/11/4
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    } // 1367/11/4


    // alert(' jalaliDate5 ' + jalaliDate5);

    return jalaliDate5;
  }

}
